"use client";

import React from "react";
import { motion } from "framer-motion";
import { Shield, Clock, CircleCheck as CheckCircle2, Star, Wrench } from 'lucide-react';
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { Badge } from "@/components/ui/badge";
const trustBadges = [{
  icon: Shield,
  text: "Vetted Local Pros"
}, {
  icon: Clock,
  text: "Flexible Scheduling"
}, {
  icon: CheckCircle2,
  text: "Direct Pro Quotes"
}];
const containerVariants = {
  hidden: {
    opacity: 0
  },
  show: {
    opacity: 1,
    transition: {
      staggerChildren: 0.1
    }
  }
};
const itemVariants = {
  hidden: {
    opacity: 0,
    y: 20
  },
  show: {
    opacity: 1,
    y: 0,
    transition: {
      duration: 0.5,
      ease: "easeOut"
    }
  }
};
export default function HeroServiceBooking() {
  return <section id="heroservicebooking" className="relative overflow-hidden bg-background py-16 md:py-24 lg:py-32">
      {}
      <div className="pointer-events-none absolute inset-0 flex items-center justify-center overflow-hidden">
        <div className="absolute -top-[20%] -right-[10%] h-[600px] w-[600px] rounded-lg bg-primary/5 blur-[100px]" />
        <div className="absolute -bottom-[20%] -left-[10%] h-[600px] w-[600px] rounded-lg bg-secondary/5 blur-[100px]" />
      </div>

      <div className="container relative mx-auto px-4 md:px-6">
        <div className="grid items-center gap-12 lg:grid-cols-2 lg:gap-8">
          {}
          <motion.div variants={containerVariants} initial="hidden" animate="show" className="flex flex-col items-start text-left">
            <motion.div variants={itemVariants} className="mb-6">
              <Badge variant="secondary" className="px-3 py-1 text-sm">
                <Wrench className="mr-2 size-4 text-primary" />
                Atlanta Metro Appliance Repair Network
              </Badge>
            </motion.div>

            <motion.h1 variants={itemVariants} className="mb-6 font-default text-4xl font-bold leading-tight tracking-tight text-foreground md:text-5xl lg:text-6xl">
              Appliance Repair in Atlanta, GA
            </motion.h1>

            <motion.p variants={itemVariants} className="mb-8 max-w-xl text-lg text-muted-foreground md:text-xl">
              Handy Heroes connects Atlanta homeowners with independent local pros for dependable refrigerator, washer, dryer, oven, and kitchen appliance repairs.
            </motion.p>

            <motion.div variants={itemVariants} className="mb-10 flex flex-col gap-4 sm:flex-row sm:flex-wrap">
              {trustBadges.map((badge, i) => {
              const Icon = badge.icon;
              return <div key={i} data-index={i} className="flex items-center gap-2 rounded-md bg-card px-4 py-2 shadow-sm">
                    <Icon className="size-5 text-primary" />
                    <span className="font-default text-sm font-medium text-card-foreground">
                      {badge.text}
                    </span>
                  </div>;
            })}
            </motion.div>

            <motion.div variants={itemVariants} className="flex w-full flex-col gap-4 sm:w-auto sm:flex-row">
              <Button size="lg" asChild className="w-full sm:w-auto">
                <Link to="#bookingrequest">
                  Request Service
                </Link>
              </Button>
              <Button size="lg" variant="outline" asChild className="w-full sm:w-auto">
                <Link to="/FindAProPage">
                  Find a Pro
                </Link>
              </Button>
            </motion.div>
          </motion.div>

          {}
          <motion.div initial={{
          opacity: 0,
          scale: 0.95
        }} animate={{
          opacity: 1,
          scale: 1
        }} transition={{
          duration: 0.7,
          ease: "easeOut",
          delay: 0.2
        }} className="relative mx-auto w-full max-w-lg lg:max-w-none">
            <div className="relative aspect-[4/3] overflow-hidden rounded-2xl shadow-2xl lg:aspect-square">
              <img src="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/appliance_repair_technician_hero.png" data-wvc-srcset="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/appliance_repair_technician_hero.png-wvc-srcset" data-wvc-sizes="https://wpvc-images.s3.us-east-1.amazonaws.com/images/1745538/img/appliance_repair_technician_hero.png-wvc-sizes" alt="Appliance repair technician inspecting kitchen refrigerator components" className="h-full w-full object-cover" loading="eager" />
              <div className="absolute inset-0 rounded-2xl ring-1 ring-inset ring-foreground/10" />
            </div>

            {}
            <motion.div initial={{
            opacity: 0,
            y: 20
          }} animate={{
            opacity: 1,
            y: 0
          }} transition={{
            duration: 0.5,
            delay: 0.8
          }} className="absolute -bottom-6 -left-6 hidden rounded-xl bg-background p-4 shadow-xl sm:block md:-left-8">
              <div className="flex items-center gap-4">
                <div className="flex h-12 w-12 items-center justify-center rounded-lg bg-primary/10">
                  <Star className="size-6 fill-primary text-primary" />
                </div>
                <div>
                  <div className="font-default text-lg font-bold text-foreground">
                    Local Service Network
                  </div>
                  <div className="text-sm text-muted-foreground">
                    Connecting Atlanta with independent pros
                  </div>
                </div>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}